import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { CivilianEmailSubscription, CivilianEmailSubscriptionRepository } from "src/app/repositories/subscription/civilian-subscription-repository";

@Component({
	selector: "jhmc-subscription",
	templateUrl: "./subscription.component.html",
	styleUrls: ["./subscription.component.scss"],
	imports: [MatFormFieldModule, MatInputModule, FormsModule,
		MatRadioModule, MatSelectModule, MatOptionModule]
})
export class SubscriptionComponent implements OnInit
{
	public email: string;
	public expirationStr: string;
	public signature: string;
	public actionUrl: string;
	public userIsSubscribed: boolean = false;
	public showPage: boolean = false;
	private emailSubscriptionRepository: CivilianEmailSubscriptionRepository;

	private route: ActivatedRoute;

	public constructor(emailSubscriptionRepository: CivilianEmailSubscriptionRepository,
		route: ActivatedRoute, router: Router)
	{
		this.route = route;
		this.emailSubscriptionRepository = emailSubscriptionRepository;
	}

	public ngOnInit(): void
	{
		this.route.queryParams.subscribe((params: Params) =>
		{
			if (params.email)
			{
				this.email = params.email;
			}
			if (params.expiration)
			{
				this.expirationStr = params.expiration;
			}
			if (params.signature)
			{
				this.signature = params.signature;
			}
			if (params.userIsSubscribed)
			{
				this.userIsSubscribed = params.userIsSubscribed;
			}
		});
	}

	public updateEmailSubscription(email: string, expirationStr: string, signature: string, subscribe: boolean): void
	{
		const emailSubscription: CivilianEmailSubscription = new CivilianEmailSubscription(
			email, expirationStr, signature, subscribe);

		this.emailSubscriptionRepository.updateSubscription(emailSubscription).subscribe({
			next: () => {
				this.userIsSubscribed = subscribe;
			},
			error: () => {
				alert("Error occurred. Subscription not updated.");
			}
		})
	}
}
